import { createSlice } from '@reduxjs/toolkit'
import { MyProfileState } from '../../types/MyProfile/ProfileTypes'
import { ApiLoadingState } from '../../middleware/api/apiList'
import { LoadingState } from '../../types/commonTypes'
import { RootState } from '../../stateStore'

// Define the initial state
const initialState: MyProfileState = {
  isLoading: ApiLoadingState.idle,
  activeTabsKey: 1,
  lastActiveTabsKey: 1,
  empId: '',
}

// Create the slice
const profileSlice = createSlice({
  name: 'myProfile',
  initialState,
  reducers: {
    setActiveTabsKeyValue: (state, action) => {
      state.activeTabsKey = action.payload
    },
    setLastActiveTabsKeyValue: (state, action) => {
      state.lastActiveTabsKey = action.payload
    },
    setEmpId: (state, action) => {
      state.empId = action.payload
    },
  },
})

const isLoading = (state: RootState): LoadingState =>
  state.profileStore.isLoading

const activeTabsKey = (state: RootState): number =>
  state.profileStore.activeTabsKey

const lastActiveTabsKey = (state: RootState): number =>
  state.profileStore.lastActiveTabsKey

const getEmpId = (state: RootState): string => state.profileStore.empId

const profileSelectors = {
  isLoading,
  activeTabsKey,
  lastActiveTabsKey,
  getEmpId,
}

export const profileThunk = {}
export const profileService = {
  ...profileThunk,
  actions: profileSlice.actions,
  selectors: profileSelectors,
}

export default profileSlice.reducer
